/*eslint-disable*/

// reactstrap components
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";

const Footer = () => {
  return (
    <footer className="footer">
      <Row className="align-items-center justify-content-xl-between">
        <Col xl="6">
          <div className="copyright text-center text-xl-left text-muted">
            © {new Date().getFullYear()}{" "}
            <a
              className="font-weight-bold ml-1"
              href="https://www.falconeye.io"
              rel="noopener noreferrer"
              target="_blank"
            >
              Falcon Eye Club
            </a>
          </div>
        </Col>

        <Col xl="6">
          <Nav className="nav-footer justify-content-center justify-content-xl-end">
          <NavItem>
              <NavLink
                href="https://www.falconeye.io"
                rel="noopener noreferrer"
                target="_blank"
              >
                Etherscan
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                href="https://twitter.com/FalconEyeClub"
                rel="noopener noreferrer"
                target="_blank"
              >
                Twitter
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="https://www.instagram.com/falconeye.io/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Instagram
              </NavLink>
            </NavItem>      
            <NavItem>
              <NavLink
                href="https://www.instagram.com/falconeye.io/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Youtube
              </NavLink>
            </NavItem>      
            <NavItem>
              <NavLink
                href="https://github.com/alsaibai/falconeye.io.git"
                rel="noopener noreferrer"
                target="_blank"
              >
                GitHub
              </NavLink>
            </NavItem>                            
          </Nav>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
